angular.module('rjmNg.services').factory 'app', [
  "appParams"
  "FEATURE_TIER"
  "CLIENT_TYPE"
  (
    appParams
    FEATURE_TIER
    CLIENT_TYPE
  ) ->

    hasFeatureFlag: (flag) ->
      return appParams.featureFlags?.hasOwnProperty(flag) and appParams.featureFlags[flag]

    getUser: ->
      return appParams.user

    getUserId: ->
      return appParams.user?.id

    getColorThemeId: ->
      return appParams.user?.colorThemeId

    getClientName: ->
      return client.name for client in appParams.clients when client.id is appParams.clientId

    isSupportUserSession: ->
      return appParams.user?.supportId isnt 0

    getSupportUserId: ->
      return appParams.user?.supportAdminId

    isImsSession: ->
      return appParams.user?.isImsSession

    userNeedsPasswordReset: ->
      return appParams.user?.randomPassword and not (@isSupportUserSession() or @isImsSession())

    isAdminUser: ->
      return appParams.clientUserRights[appParams.clientId]?.is_admin

    isBillingUser: ->
      return appParams.clientUserRights[appParams.clientId]?.is_billing

    isOverdueModalEnabled: ->
      return appParams.clientUserRights[appParams.clientId]?.overdueModalEnabled

    userHasImplementedClients: ->
      return appParams.user?.hasImplementedClients

    isReadOnlyUser: ->
      return appParams.clientUserRights[appParams.clientId]?.is_readonly

    userHasTrendEditRights: ->
      return appParams.clientUserRights[appParams.clientId]?.trend_edit_rights

    isOnlyADemoUser: ->
      return appParams.user.isOnlyADemoUser

    isDemoUser: ->
      return appParams.user.demo

    getBillingContactName: ->
      return appParams.clientUserRights[appParams.clientId]?.billingContact?.name

    getBillingContactEmail: ->
      return appParams.clientUserRights[appParams.clientId]?.billingContact?.email

    resetUserRandomPassword: ->
      appParams.user.randomPassword = 0

    clientIsImplemented: ->
      for client in appParams.clients
        if client.id is appParams.clientId
          return client.isImplemented

    getClient: ->
      _.find(appParams.clients, (client) ->
        client.id is appParams.clientId
      )

    getClients: ->
      return appParams.clients

    getClientId: ->
      return appParams.clientId

    # Attempt to get the client's default currency. If the client's default
    # currency is unset (it might be), return USD.
    getClientDefaultCurrency: ->

      if not appParams.defaultCurrency?
        throw "defaultCurrency app param is not set"

      defaultCurrency =
        appParams.defaultCurrency[appParams.clientId]

      CURRENCY_IF_DEFAULT_UNSET =
        code: 'USD'
        prefix: '$'
        suffix: ''

      return defaultCurrency ? CURRENCY_IF_DEFAULT_UNSET

    getDefaultDashboard: ->
      dashboard = _.find(appParams.dashboards, (d) ->
        d.is_default
      )

      unless dashboard?
        dashboard = appParams.dashboards[0]

      return dashboard

    getDashboard: (dashId) ->
      _.find(appParams.dashboards, (d) ->
        d.id is +dashId
      )

    getDashboards: ->
      return appParams.dashboards

    addDashboard: (dashboard) ->
      appParams.dashboards.push(dashboard)

    deleteDashboard: (dashId) ->
      appParams.dashboards = _.reject(appParams.dashboards, (d) =>
        d.id is dashId
      )

    setDefaultDashboard: (dashId) ->
      _.map(appParams.dashboards, (val, key) ->
        if(val.is_default)
          val.is_default = false

        if(val.id is dashId)
          val.is_default = true

        return val
      )

    getLockPersonalInfo: ->
      for client in @getClients()
        if client.lockPersonalInfo == "1"
          return true
      return false

    getSupportEmail: () ->
      return "support@rjmetrics.com"

    getLoginError: () ->
      appParams.loginError

    canAccessSqlReportBuilder: () ->
      @isAdminUser()

    tempDisableFeatureForAUM: () ->
      !((!@isAdminUser()) && appParams.clientUserRights[appParams.clientId]?.aumEnabled)

    isAumEnabled: () ->
      return appParams.clientUserRights[appParams.clientId]?.aumEnabled

    getGoogleAnalyticsReportingKey: () ->
      appParams.googleAnalyticsReportingKey

    canAccessDataWarehouse: () ->
      @isAdminUser() and
        (@getFeatureTier() is FEATURE_TIER.PREMIUM or @isSupportUserSession())

    getFeatureTier: () ->
      @getClient()?.featureTier

    isBillingExempt: () ->
      @getClient()?.magentoClientType in [CLIENT_TYPE.ECE, CLIENT_TYPE.EE, CLIENT_TYPE.INTERNAL, CLIENT_TYPE.DEMO, CLIENT_TYPE.MOM]

    getRjqlVersion: () ->
      if @hasFeatureFlag('RJQL_SERVICE_CLIENT') then 1.0 else 0.1

    isCohortBuilderAllowed: () ->
      @hasFeatureFlag('RJQL_SERVICE_CLIENT')

    areDashboardDividersAllowed: () ->
      @hasFeatureFlag('RJQL_SERVICE_CLIENT')

    canRawExport: () ->
      @isAdminUser() or (not @isAdminUser() and not @hasFeatureFlag('RAW_EXPORT_ADMIN_ONLY') and not @isReadOnlyUser())

    canEditPersistentViews: () ->
      @isSupportUserSession() or (@hasFeatureFlag('PERSISTENT_VIEWS_EDIT') and @isAdminUser())

    isMagentoChannels: () ->
      @getClient()?.magentoChannels is '1'

    isSignInAvailable: () ->
      return not @hasFeatureFlag('MBI_MAINTENANCE')

]
